module.exports = __webpack_public_path__ + "img/stick_activites_sensation_pleine_nature.8bb3119b.svg";